import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { FilterProps } from "../../types/AppTypes";
import { CollaboratorTypeEnum } from "../../constants/AppConstants";
import { OptionItem } from "../../components/TextSwitch/TextSwitch";

type SearchPaginationCollaborator<T> = {
  [CollaboratorTypeEnum.FOLLOW]: T;
  [CollaboratorTypeEnum.ACTIVE]: T;
};

export interface InitialStateProps {
  selectedTab: OptionItem<CollaboratorTypeEnum> | null;
  filtersCollaborator: Partial<SearchPaginationCollaborator<FilterProps[]>>;
  searchCollaborator: SearchPaginationCollaborator<string>;
  paginationCollaborator: SearchPaginationCollaborator<number>;
}

export const initialState: InitialStateProps = {
  selectedTab: null,
  filtersCollaborator: {
    [CollaboratorTypeEnum.ACTIVE]: [],
  },
  searchCollaborator: {
    [CollaboratorTypeEnum.FOLLOW]: "",
    [CollaboratorTypeEnum.ACTIVE]: "",
  },
  paginationCollaborator: {
    [CollaboratorTypeEnum.FOLLOW]: 0,
    [CollaboratorTypeEnum.ACTIVE]: 0,
  },
};

export const collaboratorSlice = createSlice({
  name: "collaborators",
  initialState,
  reducers: {
    setSelectedTab: (
      state: InitialStateProps,
      action: PayloadAction<OptionItem<CollaboratorTypeEnum>>,
    ) => {
      state.selectedTab = action.payload;
    },
    setFiltersCollaboratorActive: (
      state: InitialStateProps,
      action: PayloadAction<FilterProps[]>,
    ) => {
      state.filtersCollaborator[CollaboratorTypeEnum.ACTIVE] = action.payload;
    },
    setSearchCollaboratorFollow: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchCollaborator[CollaboratorTypeEnum.FOLLOW] = action.payload;
    },
    setSearchCollaboratorActive: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchCollaborator[CollaboratorTypeEnum.ACTIVE] = action.payload;
    },
    setPaginationCollaboratorFollow: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.paginationCollaborator[CollaboratorTypeEnum.FOLLOW] =
        action.payload;
    },
    setPaginationCollaboratorActive: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.paginationCollaborator[CollaboratorTypeEnum.ACTIVE] =
        action.payload;
    },
    resetCollaboratorState: () => initialState,
  },
});

export const {
  setSelectedTab,
  setFiltersCollaboratorActive,
  setPaginationCollaboratorActive,
  resetCollaboratorState,
  setPaginationCollaboratorFollow,
  setSearchCollaboratorActive,
  setSearchCollaboratorFollow,
} = collaboratorSlice.actions;
export default collaboratorSlice.reducer;
